import { TypeExpertise } from './type-expertise';
import { User } from './user';
import { Contact } from './contact';
import { Prestation } from './prestation';
import * as moment from 'moment';

export class InvoiceDetail {

  public loading: boolean;

	public id: number;
	public article: string;
	public description: string;
	public quantity: number;
  public rate: number;
  public pu: number;
  
  	constructor(
  	) {}


    public toRequest(): any {
      
      let a = Object.assign({},{
        id: this.id,
        article: this.article,
        description: this.description,
        pu: this.pu,
        quantity: this.quantity,
        rate: this.rate,
      });
      return a;
    }

    get total(): any {
      return this.quantity * this.pu;
    }
}
